import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useRecordContext } from "ra-core";
import { DocumentServicePath } from "utils/constants";

const CustomDocumentButton = props => {
  const navigate = useNavigate();
  const record = useRecordContext(props);
  if (!record) return null;

  return (
    <Button
      color="primary"
      size="small"
      startIcon={<AddIcon />}
      onClick={() => navigate(`/${DocumentServicePath}add-documents/declarations/${record.id}`)}
      label="Добави документи"
    >
      Добави документи
    </Button>
  );
};

export default CustomDocumentButton;
